import { createSelector } from 'reselect'

const selectBranches = (state) => state.branches

export const selectBranchIsLoading = createSelector([selectBranches], (branches) => branches.isLoading)

export const selectBranchItems = createSelector([selectBranches], (branches) => branches.branchItems)

export const selectBranchItemsMapped = createSelector([selectBranchItems], (branchItems) =>
  branchItems
    ? branchItems.map((item) => {
        return { value: item._id, label: item.name }
      })
    : []
)
